// extracted by mini-css-extract-plugin
export default {"form-slide-content":"FormSlide_form-slide-content__SsKok","hidden":"FormSlide_hidden__rRqFS"};